import React from 'react'

const PageNameV2 = React.memo(({title1, title2}) => {
  return (
    <p className="pageName mt-15 fs-14">{ title1 } > { title2 }</p>
  );
});

export default PageNameV2;